import { useMutation, useQuery } from "@tanstack/react-query";
import { ApiResponse } from "../../apis/data";
import { queryKey } from "../../enumerations/queryKey";
import {
  CheckoutParams,
  CompanionParams,
  PaymentParams,
  PaymentResponse,
} from "./data";
import {
  apiCheckout,
  apiCreatePayment,
  apiGetPaymentMethodList,
  apiUpdateCompanion,
} from "./service";

export const useGetPaymentMethod = (options: any) => {
  return useQuery<PaymentResponse[]>({
    queryKey: [queryKey.PAYMENT_METHOD_LIST],
    queryFn: () =>
      apiGetPaymentMethodList().then(
        (res: ApiResponse<PaymentResponse[]>) => res.data.data
      ),
    ...options,
  });
};

export const useCheckout = () => {
  return useMutation({
    mutationFn: ({ params }: { params: CheckoutParams }) => apiCheckout(params),
  });
};

export const usePay = () => {
  return useMutation({
    mutationFn: ({ params }: { params: PaymentParams }) =>
      apiCreatePayment(params),
  });
};

export const useUpdateCompanion = () => {
  return useMutation({
    mutationFn: ({ params }: { params: CompanionParams }) =>
      apiUpdateCompanion(params),
  });
};
